<template>
  <div class="wrap">
    <div class="wrap-content">
      <div class="add-btn" @click="$refs['ProductEditAddress'].open()">
        新增收货地址
      </div>
      <div class="list">
        <div class="list-item" v-for="item in list">
          <div class="place-default">
            <div class="place">
              {{ item.pro_name }}{{ item.city_name }} {{ item.county_name }}
              {{ item.add_detail }}
            </div>
            <div class="default" v-if="item.is_mr">默认</div>
          </div>
          <div class="name-phone">
            {{ item.name }} <span>{{ item.phone }}</span>
          </div>
          <div class="btn-box">
            <div
              class="edit-btn"
              @click="$refs['ProductEditAddress'].open(item)"
            >
              编辑地址
            </div>
            <div
              class="default-btn"
              v-if="!item.is_mr"
              @click="setDefaultAddress(item)"
            >
              设为默认
            </div>
            <div class="del-btn" @click="handleDelete(item)">删除地址</div>
          </div>
        </div>
      </div>
    </div>
    <ProductEditAddress
      ref="ProductEditAddress"
      @handleClose="getAddressList()"
    />
  </div>
</template>

<script>
import { AddressService } from "@/common/service";
import ProductEditAddress from "@/components/product/product-edit-address.vue";
export default {
  components: { ProductEditAddress },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      AddressService.getDeliveryAddressList({ page: 1, page_num: 20 }).then(
        ({ data }) => {
          this.list = data.list;
        }
      );
    },
    // 设置默认地址
    setDefaultAddress(item) {
      AddressService.changeApproveDelivery({ id: item.id, is_mr: 1 }).then(
        ({ msg }) => {
          this.$message.success(msg);
          this.getList();
        }
      );
    },
    handleDelete(item) {
      AddressService.delDeliveryAddress({ id: item.id }).then(({ msg }) => {
        this.$message.success(msg);
        this.getList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: calc(100% - 120px - 100px);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 900px;
  .wrap-content {
    width: 70%;
    .add-btn {
      width: 160px;
      height: 54px;
      background: #2a63f3;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 54px;
    }
    .list {
      margin-top: 20px;
      .list-item {
        height: 100px;
        background: white;
        border-radius: 12px;
        position: relative;
        box-sizing: border-box;
        margin-bottom: 20px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .place-default {
          display: flex;
          align-items: center;
          .place {
            font-size: 20px;
            font-weight: 500;
            color: #141414;
          }
          .default {
            width: 48px;
            height: 20px;
            background: #0054f7;
            border-radius: 10px;
            font-size: 10px;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 20px;
            margin-left: 10px;
          }
        }
        .name-phone {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          span {
            margin-left: 10px;
          }
        }
        .btn-box {
          display: flex;
          position: absolute;
          left: calc(100% + 10px);
          bottom: 0;
          div {
            width: 70px;
            height: 70px;
            border-radius: 10px;
            text-align: center;
            box-sizing: border-box;
            padding: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
            user-select: none;
            font-size: 12px;
            cursor: pointer;
            margin-right: 10px;
          }
          .del-btn {
            background-color: #e5e5e5;
            color: #999999;
          }
          .edit-btn {
            background-color: white;
            color: #2a63f3;
          }
          .default-btn {
            background: #e5e5e5;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
